import { OrderStatus } from 'plugins/Constant'
import { copyright, userform } from 'commons/locale'

const values = {
  appro: '待评估',
  choose: '选填',
  colon: '：',
  comma: '，',
  disdata: '无法解析',
  multiply: '×',
  must: '必填',
  none: '无',
  null: '--',
  or: '或',
  range: '～',
  this: '该',
  without: '暂无'
}

const unit = {
  currency: '元',
  currencySymbol: '￥',
  date: '天',
  weight: '克',
  amount: '个'
}

const actions = {
  target: {
    all: '全部',
    already: '已',
    attach: '附件',
    auto: '自动',
    comm: '备注',
    complete: '完成',
    content: '内容',
    data: '数据',
    date: '日期',
    default: '默认',
    demand: '需求',
    describe: '说明',
    detail: '详情',
    file: '文件',
    go: '去',
    immedi: '立即',
    info: '信息',
    launch: '发起',
    list: '列表',
    manual: '人工',
    mine: '我的',
    name: '名称',
    new: '新',
    no: '不',
    not: '未',
    old: '原',
    op: '操作',
    options: '选项',
    other: '其他',
    params: '参数',
    period: '周期',
    price: '价格',
    reason: '原因',
    selected: '所选',
    simple: '快速',
    start: '开始',
    status: '状态',
    suggest: '意见',
    template: '模板',
    time: '时间',
    type: '方式',
    user: '用户',
    wait: '等待'
  },
  add: '添加',
  agree: '同意',
  browse: '浏览',
  buy: '购买',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  contact: '联系客服',
  create: '新建',
  del: '删除',
  deliver: '发货',
  delivery: '收货',
  dispose: '处理',
  download: '下载',
  draw: '开',
  edit: '编辑',
  estimate: '预估',
  filter: '过滤',
  forgot: '忘记',
  found: '创建',
  get: '获取',
  getback: '找回',
  goback: '返回',
  goon: '继续',
  increase: '新增',
  inquiry: '询价',
  login: '登录',
  loging: '使用已有账户登录',
  logout: '注销',
  look: '查看',
  modify: '修改',
  more: '更多',
  need: '需要',
  next: '下一步',
  obtain: '收款',
  ok: '确定',
  order: '下单',
  pay: '支付',
  payment: '付款',
  preview: '预览',
  print: '打印',
  produce: '生产',
  push: '加入',
  quote: '报价',
  refund: '退款',
  record: '记录',
  reg: '注册',
  reject: '拒绝',
  request: '申请',
  routo: '跳转到',
  save: '保存',
  search: '搜索',
  select: '选择',
  selectall: '全选',
  send: '发送',
  seto: '设为',
  setting: '设置',
  sign: '签收',
  submit: '提交',
  think: '我再想想',
  total: '合计',
  update: '更新',
  upload: '上传',
  unselectall: '全不选',
  verify: '审核',
  write: '填写',
  evaluate: '评价'
}

const message = {
  name: '消息',
  title: {
    alert: '警告',
    confirm: '确认',
    info: '提示',
    prompt: '输入'
  },
  field: {
    from: '发信人'
  },
  content: {
    confirm: '您确定要%吗？',
    doing: '正在努力加载，请稍后……',
    error: '%失败，请稍后重试！',
    disformat: '%格式不正确！',
    ignore: '没有%，确定要放弃吗？',
    input: '请输入%',
    select: '请选择%',
    success: '%成功！',
    textover: '最多输入%个字',
    undo: '您还没有%！',
    unstore: '操作不能恢复，您确定%吗？',
    wrong: '%输入有误！'
  }
}

const demand = {
  field: {
    scope: '服务模块',
    type: '类型',
    username: '称呼',
    status: '情况'
  },
  type: {
    personal: '个人',
    company: '企业'
  },
  scope: {
    scan: '扫描',
    design: '设计',
    simulate: '仿真'
  }
}

const navs = {
  personal: {
    index: '首页',
    print3D: '3D打印服务',
    market: '创客集市'
  },
  factory: {
    index: '首页',
    print3D: '3D打印服务',
    market: '创客集市'
  },
  maintenance: {
    index: '首页',
    print3D: '3D打印服务',
    market: '创客集市'
  },
  userMenu: {
    personal_center: '个人中心',
    factory_center: '用户中心',
    maintenance_center: '管理中心',
    branch: {
      space: '我的动态',
      seller: '卖家中心'
    },
    market: {
      shop: '我要开店'
    },
    logout: '注销'
  }
}

const process3D = {
  require: {
    title: '上传模型',
    hint: {
      intocart: '成功加入购物车，您可以添加新的打印需求！'
    }
  },
  mycart: {
    name: '购物车',
    title: '我的购物车',
    hint: {
      cost: '模型未满起步价时，以起步价格计算，多模型同材料下单可折合起步价，最终价格以支付页面为准'
    },
    total: '共计%个'
  },
  inquiry: {
    title: '人工询价',
    hint: {
      next: '跳转到%查看订单进度',
      success: '请等待工作人员为您报价！'
    }
  },
  payment: {
    title: '确认支付',
    type: {
      alipay: '支付宝',
      offline: '线下支付'
    },
    hint: {
      alipay: '请使用支付宝APP扫码完成支付！',
      offline: '请通过银行转账！',
      pay: '汇款后，请等待财务人员审核后确认支付完成，您可以在“%”中查看订单状态。',
      voucher: '请汇款后上传截图或将银行回单拍照作为付款凭证，如图所示：%',
      next: '跳转到%查看订单进度',
      success: '平台确认收款后将为您安排打印，请耐心等待！',
      confirm: '请确认是否收到用户<b>%1</b>订单号<b>%2</b>订单的款项<b>%3</b>？<br/>以下是支付凭证：'
    }
  },
  produce: {
    title: '生产打印',
    hint: {
      confirm: '你确认要开始当前订单的生产打印操作？'
    }
  },
  delivery: {
    title: '快递交付',
    hint: {
      confirm: '你确认收到货物？',
      discontent: '收到商品不满意？',
      contact: '如对商品不满意，请联系客服'
    }
  }
}
const process3DMobile = {
  require: {
    title: '上传模型',
    hint: {
      intocart: '成功加入购物车，您可以添加新的打印需求！'
    }
  },
  inquiry: {
    title: '人工询价',
    hint: {
      next: '跳转到%查看订单进度',
      success: '请等待工作人员为您报价！'
    }
  },
  produce: {
    title: '下单打印',
    hint: {
      confirm: '你确认要开始当前订单的生产打印操作？'
    }
  },
  delivery: {
    title: '快递交付',
    hint: {
      confirm: '你确认收到货物？',
      discontent: '收到商品不满意？',
      contact: '如对商品不满意，请联系客服'
    }
  }
}
const model = {
  title: '文件基本信息',
  filetype: '三维格式',
  name: '模型',
  field: {
    fileSize: '文件大小',
    size: '尺寸（mm）',
    sizeAlias: '外形尺寸',
    volume: '体积（cm³）',
    area: '表面积（cm²）',
    num: '数量',
    used: '用途'
  },
  used: [
    '功能件',
    '原型件',
    '其他'
  ],
  hint: {
    nomodel: '没有模型？%建模',
    modify: '您已更新模型，平台将为您重新询价！'
  }
}

const materials = {
  title: '可选材料',
  name: '材料',
  field: {
    category: '类别',
    color: '颜色',
    precision: '精度',
    desc: '简介',
    readed: '阅读',
    tag: '标签',
    realm: '应用领域'
  },
  hint: {
    disavailable: '不支持打印当前格式的模型'
  }
}

const machine = {
  title: '打印机械',
  name: '机械',
  field: {
    material: '适用材料',
    moldsize: '成型尺寸',
    ratio: '层分辨率',
    depth: '铺粉厚度',
    mindot: '最小特征点',
    precision: '打印精度'
  }
}

const print = {
  title: '打印信息',
  field: {
    type: '方式',
    material: '使用材料',
    maxsize: '最大尺寸（mm）',
    filling: '填充',
    consumed: '耗材量',
    support: '支撑'
  },
  size: ['长度', '宽度', '高度'],
  hint: {
    over: '模型“%”超出最大打印尺寸，请重新选择打印方式！'
  }
}

const technology = {
  title: '表面处理',
  name: '工艺',
  field: {
    type: '处理工艺',
    params: '工艺设置'
  },
  color: {
    count: [
      '一种颜色',
      '两种颜色',
      '三种颜色',
      '四种颜色',
      '五种颜色'
    ],
    set: {
      pantonematte: '哑光潘通色',
      pantonehigh: '高光潘通色'
    },
    placeholder: '输入色号',
    hint: '请设置表面处理中所选的%！'
  },
  comments: '（可选）'
}

const upload = {
  title: '上传3D模型',
  field: {
    speed: '传输速率',
    percent: '已完成'
  },
  thumbs: ['', '主视图', '俯视图', '左视图'],
  hint: {
    illustration: '推荐上传STL格式文件，文件限小于100M；<br/>同时支持obj、stp、wrl、prt等其它格式3D模型文件，但不支持预览与解析。',
    formaterror: '不允许上传此格式的文件！',
    oversize: '文件大小超出限制！'
  }
}

const preview = {
  hint: {
    nonsupport: '不支持此格式文件预览与解析！',
    oversize: '不支持大于%M的文件预览与解析！'
  }
}

const addon = {
  title: '订单配置',
  field: {
    selected: '选定结果'
  }
}

const address = {
  name: '收货地址',
  field: {
    name: '收货人',
    realname: '真实姓名',
    phone: '联系电话',
    region: '所在地区',
    street: '详细地址',
    zip: '邮政编码'
  },
  hint: {
    phone: '手机号码',
    street: '需精确到门牌号',
    zip: '六位数字'
  }
}
const evaluate = {
  modal: ['评价商品', '发表评价'],
  form: {
    item: ['商品评分:', '评&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价:', '晒&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;图:'],
    msg: ['必填项']
  }
}
const trade = {
  name: '订单',
  field: {
    id: '订单号',
    orderNum: '序号',
    progress: '进度',
    commodity: '商品',
    price: '单价',
    amount: '金额',
    totalAmount: '总商品金额',
    totalSurfaceAmount: '总表面处理金额',
    discountAmount: '折扣',
    diffAmount: '差价',
    logisticsAmount: '运费',
    orderAmount: '总金额',
    estimateWeight: '总耗材量',
    buyer: '购买人',
    voucher: '汇款凭证'
  },
  process: ['提交需求成功', '平台报价', '支付成功', '工厂打印', '卖家发货', '买家收货'],
  status: {
    [OrderStatus.BeforeInquiry]: '待报价',
    [OrderStatus.OnInquiry]: '报价中',
    [OrderStatus.BeforePayment]: '待付款',
    [OrderStatus.OnPayment]: '等待买家付款',
    [OrderStatus.AfterPayment]: '已付款',
    [OrderStatus.OnPaymentConfirm]: '确认收款',
    [OrderStatus.AfterPaymentConfirm]: '已收款',
    [OrderStatus.BeforeRefund]: '退款审核中',
    [OrderStatus.OnRefund]: '退款中',
    [OrderStatus.AfterRefund]: '已退款',
    [OrderStatus.BeforeProduce]: '待打印',
    [OrderStatus.OnProduce]: '打印中',
    [OrderStatus.BeforeDelivery]: '待发货',
    [OrderStatus.AfterDelivery]: '已发货',
    [OrderStatus.BeforeSign]: '待收货',
    [OrderStatus.BeforeCancel]: '取消交易',
    [OrderStatus.AfterCancel]: '交易取消',
    [OrderStatus.AfterSign]: '已签收',
    [OrderStatus.Succeed]: '交易成功',
    [OrderStatus.Finished]: '交易完成',
    [OrderStatus.Closed]: '已关闭'
  },
  refundReason: [
    '不想要了',
    '一直未发货',
    '其他原因'
  ],
  hint: {
    cycle: '天数，如：5、6-8',
    range: '退款金额不能大于订单金额%元！',
    refunded: '请确认已完成退款操作？'
  }
}

const invoice = {
  name: '发票',
  field: {
    head: '抬头',
    taxNo: '税号',
    type: '类型',
    amount: '金额',
    companyName: '单位名称',
    companyAddress: '注册地址',
    companyTel: '注册电话',
    bankName: '开户银行',
    bankAccount: '银行账户',
    accountName: '开户名称',
    billNum: '支付单号',
    sellerName: '卖家名称'
  },
  type: {
    '0': '普通',
    '1': '专用',
    '2': '个人'
  },
  upload: '上传头像',
  placeholder: {
    title: '个人/单位名称',
    taxNo: '纳税人识别号',
    content: '空为默认服务费',
    companyName: '单位名称',
    companyAddress: '注册地址'
  },
  hint: {
    companyTel: '请输入电话，固定电话带区号',
    require: '请先填写发票信息'
  }
}
// 图片编辑列表
const imageUploadList = {
  label: '图片',
  cover: '封面图',
  forward: '前移',
  backward: '后移',
  msg_size: '图片大小不能超过{0}MB！',
  accept: '请选择正确的图片！'
}

const logistics = {
  name: '物流',
  field: {
    expressNo: '快递单号',
    merchants: '物流公司'
  },
  default: '顺丰快递'
}

const role = {
  name: '角色'
}

export {
  copyright,
  values,
  unit,
  actions,
  navs,
  message,
  userform,
  demand,
  trade,
  model,
  materials,
  machine,
  process3D,
  process3DMobile,
  print,
  technology,
  upload,
  preview,
  addon,
  address,
  evaluate,
  invoice,
  imageUploadList,
  logistics,
  role
}



// WEBPACK FOOTER //
// ./src/assets/lang/charset/en.js